if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.MS_IN_SEC = 1000;
        this.MS_IN_MIN = 60 * this.MS_IN_SEC;
        this.MS_IN_HRS = 60 * this.MS_IN_MIN;
        this.MS_IN_DAY = 24 * this.MS_IN_HRS;

        this.selectorMapping = {
          day: '[data-timer-day]',
          hour: '[data-timer-hour]',
          minute: '[data-timer-minute]',
          second: '[data-timer-second]',
        };

        this.units = ['day', 'hour', 'minute', 'second'];

        this.type = this.dataset.type;
        this.duration = this.dataset.duration;

        this.loop = false;
        this.shouldAddLeadingZero = true;

        this.initCountdown();
      }

      initCountdown() {
        switch (this.type) {
          case 'fixed_time': {
            const countdownData = this.dataset.dueDate;
            if (countdownData) {
              this.targetTime = new Date(countdownData).getTime();
            }
            break;
          }
          default: {
            this.targetTime = this.getEvergreenDueDate().getTime();
            break;
          }
        }

        if (!this.targetTime) return;

        this.startTime = Date.now();

        if (this.targetTime > this.startTime) {
          this.fetchDomElements();
          this.beginCountdown();
        }
      }

      fetchDomElements() {
        this.elements = {};
        this.units.forEach((unit) => {
          this.elements[unit] = this.querySelector(this.selectorMapping[unit]);
        });
      }

      beginCountdown() {
        this.intervalId = setInterval(() => {
          const remainingTime = this.targetTime - Date.now();

          if (remainingTime <= 0) {
            this.terminateCountdown();
          } else {
            this.updateDisplay(remainingTime);
          }
        }, 1000);

        this.classList.remove('hidden');
      }

      updateDisplay(remainingTime) {
        const timeComponents = this.computeTimeComponents(remainingTime);

        this.units.forEach((unit) => {
          if (this.elements[unit]) {
            this.elements[unit].textContent =
              this.formatTimeComponent(timeComponents[unit]);
          }
        });
      }

      computeTimeComponents(ms) {
        return {
          day: Math.floor(ms / this.MS_IN_DAY),
          hour: Math.floor((ms % this.MS_IN_DAY) / this.MS_IN_HRS),
          minute: Math.floor((ms % this.MS_IN_HRS) / this.MS_IN_MIN),
          second: Math.floor((ms % this.MS_IN_MIN) / this.MS_IN_SEC),
        };
      }

      formatTimeComponent(value) {
        return this.shouldAddLeadingZero && value < 10
          ? `0${value}`
          : value.toString();
      }

      terminateCountdown() {
        clearInterval(this.intervalId);

        if (this.loop) {
          this.targetTime = this.getEvergreenDueDate().getTime();
          this.beginCountdown();
        } else {
          this.classList.add('hidden');
        }
      }

      resetCountdown() {
        clearInterval(this.intervalId);

        this.units.forEach((unit) => {
          if (this.elements[unit]) {
            this.elements[unit].textContent = '00';
          }
        });
      }

      /**
       * ✅ 核心重构点
       * 使用“时间对齐算法”，替代 startPoints + for 循环
       */
      getEvergreenDueDate() {
        const now = new Date();
        const dueDate = new Date(now);

        switch (this.duration) {
          case 'every_month': {
            dueDate.setMonth(dueDate.getMonth() + 1);
            dueDate.setDate(1);
            dueDate.setHours(0, 0, 0, 0);
            return dueDate;
          }

          case 'every_week': {
            const dayOfWeek = now.getDay();
            const daysUntilNextWeek = 7 - dayOfWeek;

            dueDate.setDate(now.getDate() + daysUntilNextWeek);
            dueDate.setHours(0, 0, 0, 0);
            return dueDate;
          }

          default: {
            const intervalMap = {
              every_1_hrs: 60,
              every_2_hrs: 120,
              every_6_hrs: 360,
              every_12_hrs: 720,
              every_24_hrs: 1440,
              every_half_hrs: 30,
            };

            const intervalMinutes = intervalMap[this.duration];

            if (!intervalMinutes) return null;

            const currentMinutes =
              now.getHours() * 60 + now.getMinutes();

            const isExact = currentMinutes % intervalMinutes === 0;

            const nextMinutes = isExact
              ? currentMinutes
              : Math.ceil(currentMinutes / intervalMinutes) *
                intervalMinutes;

            const daysToAdd =
              nextMinutes >= 24 * 60 ? 1 : 0;

            const finalMinutes =
              nextMinutes % (24 * 60);

            const hours = Math.floor(finalMinutes / 60);
            const minutes = finalMinutes % 60;

            dueDate.setDate(now.getDate() + daysToAdd);
            dueDate.setHours(hours, minutes, 0, 0);

            return dueDate;
          }
        }
      }
    }
  );
}